import React from "react"
import { Box } from "@mui/material"
import {
	Edit,
	NumberInput,
	required,
	SimpleForm,
	TextInput,
	useNotify,
	useRedirect,
	useRefresh
} from "react-admin"

import sx from "utils/sx"

const PatronagePackEdit = () => {
	const notify = useNotify()
	const refresh = useRefresh()
	const redirect = useRedirect()

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onSuccess = (data: any) => {
		notify(
			"resources.patronage_packs.notifications.edit",
			{
				type: "info",
				messageArgs: { name: data.name }
			}
		)
		redirect("/patronage-packs")
		refresh()
	}

	return (
		<Edit
			mutationOptions={{ onSuccess }}
			mutationMode="pessimistic"
			title="resources.patronage_packs.edit"
		>
			<SimpleForm>
				<Box sx={sx.prose}>
					<TextInput
						source="name"
						label="resources.patronage_packs.fields.name"
						validate={required()}
						fullWidth
					/>
					<NumberInput
						label="resources.patronage_packs.fields.price"
						source="price"
						validate={required()}
						fullWidth
					/>
					<NumberInput
						label="resources.patronage_packs.fields.ticket_numbers"
						source="ticketNumbers"
						validate={required()}
						fullWidth
					/>
				</Box>
			</SimpleForm>
		</Edit>
	)
}


export default PatronagePackEdit
